import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'
import { AgendaRouter } from './agenda/_router'
import { OperationsAircraftCleaningRouter } from './aircraft-cleaning/_router'
import { OperationsAirportCostsRouter } from './airport-costs/_router'
import { OperationsAvlProposalsRouter } from './avl-proposals/_router'
import { DispatchRouter } from './dispatch/_router'
import { OperationsFuelPricesRouter } from './fuel-prices/_router'
import { OperationsFuelQualityRouter } from './fuel-quality/_router'
import { GeneralDeclarationRouter } from './general-declaration/_router'
import { HotelRouter } from './hotel/_router'
import { HotelBookingRouter } from './hotel-booking/_router'
import { MissionRouter } from './mission/_router'
import { MissionMonthlyOverviewRouter } from './mission-monthly-overview/_router'
import { OperationsOptimizationReportRouter } from './optimization-report/_router'
import { OvernightsRouter } from './overnights/_router'
import { PassengerRouter } from './passenger/_router'
import { QuoteRouter as QuoteV2Router } from './quote_v2/_router'
import { RefuelEuRouter } from './refuel-eu/_router'
import { OperationsVolunteerCallsRouter } from './volunteer-calls/_router'

const Index = lazy(() => import('./Index'))

export const OperationsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations']}>
    <Route index element={<Index />} />
    <Route path='agenda/*' element={<AgendaRouter />} />
    <Route path='dispatch/*' element={<DispatchRouter />} />
    <Route path='mission/*' element={<MissionRouter />} />
    <Route path='mission-monthly-overview/*' element={<MissionMonthlyOverviewRouter />} />
    <Route path='quote_v2/*' element={<QuoteV2Router />} />
    <Route path='general-declaration/*' element={<GeneralDeclarationRouter />} />
    <Route path='passenger/*' element={<PassengerRouter />} />
    <Route path='hotel/*' element={<HotelRouter />} />
    <Route path='hotel-booking/*' element={<HotelBookingRouter />} />
    <Route path='overnights/*' element={<OvernightsRouter />} />
    <Route path='refuel-eu/*' element={<RefuelEuRouter />} />
    <Route path='airport-costs/*' element={<OperationsAirportCostsRouter />} />
    <Route path='avl-proposals/*' element={<OperationsAvlProposalsRouter />} />
    <Route path='aircraft-cleaning/*' element={<OperationsAircraftCleaningRouter />} />
    <Route path='optimization-report/*' element={<OperationsOptimizationReportRouter />} />
    <Route path='fuel-quality/*' element={<OperationsFuelQualityRouter />} />
    <Route path='fuel-prices/*' element={<OperationsFuelPricesRouter />} />
    <Route path='volunteer-calls/*' element={<OperationsVolunteerCallsRouter />} />
  </SubRouter>
))
